import type {
  CaseStudy,
  CaseStudyTestimonial,
} from '@rumblefish/strapi/strapiTypes';
import type { AdditionalInfoProps, OtherCaseStudy } from './CaseStudy.types';

export class AdditionalData {
  constructor(
    private caseStudy: CaseStudy,
    private otherCaseStudies: OtherCaseStudy[]
  ) {}

  caseStudyProps(
    caseStudy: CaseStudy,
    description: 'Previous project' | 'More recent project'
  ) {
    const { subtitle, image, slug } = caseStudy || {};
    return {
      title: subtitle || '',
      description,
      image: image?.url || '',
      slug: slug || '',
    };
  }

  get additionalInfoProps(): AdditionalInfoProps {
    const testimonialData =
      this.caseStudy.case_study_testimonials?.[0] ??
      ({} as Partial<CaseStudyTestimonial>);

    const authorData = testimonialData.author;
    return {
      testimonial: {
        avatarSrc: authorData?.Avatar?.url || '',
        name: authorData?.Name || '',
        positionInCompany: authorData?.Position || '',
        text: testimonialData?.content || '',
      },
      lastCaseStudies: this.lastCaseStudies,
    };
  }

  get lastCaseStudies() {
    return {
      firstCaseStudy: this.caseStudyProps(
        this.otherCaseStudies[0]?.data,
        this.otherCaseStudies[0]?.type === 'previous'
          ? 'Previous project'
          : 'More recent project'
      ),
      secondCaseStudy: this.caseStudyProps(
        this.otherCaseStudies[1]?.data,
        this.otherCaseStudies[1]?.type === 'previous'
          ? 'Previous project'
          : 'More recent project'
      ),
    };
  }
}
